// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3QK3h","header":"MessagesList_header__1T55-","chat":"MessagesList_chat__IMF-2"};